export enum StepEnum {
  sender = 1,
  contacts = 2,
  sendEmail = 3,
  finished = 0,
}
